module.exports = __webpack_public_path__ + "img/noShequPic.ec391770.png";